import { ReportProblem as ReportProblemIcon } from '@mui/icons-material';

const Warning = (): JSX.Element => <ReportProblemIcon fontSize="inherit" />;

export default Warning;
